import Header from '@/components/header';
import { refreshPageWarning } from '@/constants/constants';
import { theme } from '@/theme';
import { Box, ThemeProvider } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { mainLayoutStyles } from './styles';

interface MainLayoutProps {
  children: ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = refreshPageWarning;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Box sx={mainLayoutStyles.portalLayoutContainerStyle}>
        <Box sx={mainLayoutStyles.purpleEllipseStyle} />
        <Box sx={mainLayoutStyles.greenEllipseStyle} />
        <Box sx={mainLayoutStyles.headerContainer}>
          <Header />
        </Box>
        <Box sx={mainLayoutStyles.contentContainer}>{children}</Box>
      </Box>
    </ThemeProvider>
  );
};

export default MainLayout;
